<template>
	<div class="contents-wrap">
		<div class="result">
			<transition name="slide-fade">
				<div class="answer-wrap">
					<div class="answer-title">
						★熟睡度40％
						<div class="text"> 睡眠不足がかなり蓄積されているかもしれません。</div>
					</div>
					<div class="answer-body">
						<p>生活リズムが崩れ、睡眠の質が下がってしまっているようです。毎日同じくらいの時間に就寝・起床するよう心がけ、リズムを整えていきましょう。睡眠リズムを崩しやすい「休日の寝溜め」は避けたいところ。睡眠時間をしっかり確保するとともに、睡眠の質を向上させていきましょう。また、覚醒作用のあるカフェインや、中途覚醒を招きやすくするアルコールについては控えるように意識してみてください。</p>
						<div class="sub-cts"><h2>★さらにぐっすり眠るためには？</h2>
							<p>「就寝前のスマホチェックを控える」「入眠儀式を作る」など、睡眠の質を高める工夫がオススメです。ささいなことに見える行動も、続けるうちにだんだん寝付きが良くなっていき、睡眠の質もUPします。</p>
						</div>
						<div class="sub-cts">
							<h2>▼こちらもCHECK</h2>
							<ul>
								<li><a href="https://xn--z8js3azm.com/beauty/13">夜はスマホを置いてリラックス♪“なかなか眠れない”を防ぐ簡単なおすすめ習慣</a></li>
								<li><a href="https://xn--z8js3azm.com/beauty/28">パワーナップで午後の仕事もサクサク♪短い仮眠の実践法と3つのポイント</a></li>
							</ul>
						</div>
					</div>
					<div class="btn-area">
						<button @click="next(0)" class="btnReset">スタートに戻る</button>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>
<script>
export default {
	name: 'ResultCts03',
	methods: {
		next(page) {
			this.$store.dispatch('next', page)
		},
		onComplete: function () {
			this.btnFlg = true;
		}
	}
}
</script>